import { Routes, Route, Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./contexts/Authentication/AuthContext";
import Pagina404 from "./pages/Page404";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

function RequireNoAuth({ children }: { children: JSX.Element }) {
  const { isAuthenticated } = useContext(AuthContext);
  if (isAuthenticated === true) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export function Routess() {
  return (
    <Routes>
      {["/", "/:shortToken"].map((path, index) => (
        <Route key={index} path={path} element={<Home />} />
      ))}
      {["/new", "/:shortToken/new"].map((path, index) => (
        <Route key={index} path={path} element={<Home newPage={true} />} />
      ))}
      {[
        "/dashboard/:mode/:id",
        "/dashboard/:mode/:id/:shortToken",
        "/dashboard/:mode/:id/new",
        "/dashboard/:mode/:id/new/:shortToken",
      ].map((path, index) => (
        <Route key={index} path={path} element={<Dashboard />} />
      ))}
      <Route
        path="/login"
        element={
          <RequireNoAuth>
            <Login />
          </RequireNoAuth>
        }
      />
      <Route path="*" element={<Pagina404 />} />
    </Routes>
  );
}
